import { createFileRoute, useRouter } from '@tanstack/react-router'
import AddNewTask from '../../../../../../containers/TaskList/components/add-new-task'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/tasks/new/'
)({
  component: RouteComponent
})

function RouteComponent() {
  const router = useRouter()
  const navigate = Route.useNavigate()
  const { projectId } = Route.useParams()
  const search = Route.useSearch()

  const closeNewTaskPopup = () => {
    if (router.history.canGoBack()) {
      router.history.back()
      return
    }

    navigate({
      to: `/project/${projectId}/tasks`,
      search
    })
  }

  return <AddNewTask projectId={projectId} closePopup={closeNewTaskPopup} />
}
